'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VideoEmbedCodeField = require('./components/VideoEmbedCodeField');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VideoEmbedCodeField).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/video-embed-code-field/index.js
// module id = 552
// module chunks = 1